import { getThumbnailSize } from './helpers'
import styles from './ItemRow.module.scss'
import { ItemRowBody } from './ItemRowBody'
import { type ItemRowProps } from './types'
import { ProductCounter } from '@/tools/ui'
import { ItemRowSkeleton } from '@/tools/ui/components'

export const ItemRow: React.FC<ItemRowProps> = ({
  children,
  counterVariant,
  quantity,
  onAdd: handleOnAdd,
  onRemove: handleOnRemove,
  onClick: handleOnClick,
  isLoading = false,
  ...bodyProps
}) => {
  const thumbnailSize = getThumbnailSize(bodyProps.size)

  return isLoading ? (
    <ItemRowSkeleton />
  ) : (
    <div className={styles.itemRow}>
      <ItemRowBody
        {...bodyProps}
        aria-labelledby={bodyProps.title}
        size={thumbnailSize}
        onClick={handleOnClick}
      />
      <div className={children ? styles.itemRowFooter : styles.itemRowFooterFloating}>
        {children}
        <ProductCounter
          disabled={bodyProps.disabled}
          value={quantity}
          variant={counterVariant}
          onAdd={handleOnAdd}
          onRemove={handleOnRemove}
        />
      </div>
    </div>
  )
}
